import { Col, Row } from "antd";
import React from "react";
const IncomeStaffTotal = ({ record }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  if (record) {
    const total = record?.subtotal;
    return (
      <Col span={24}>
        <Row justify="space-between">
          <Col>Total value:</Col>
          <Col>${total}</Col>
        </Row>
      </Col>
    );
  }
  return null;
};
export default IncomeStaffTotal;
